import {Link} from 'react-router-dom';
import {useState} from 'react';
import {ReactComponent as Logo} from '../../assets/icons/logo.svg'
import {ReactComponent as Menu} from '../../assets/icons/menu-White.svg'
import {Navigation} from '../../modules/Navigation';
import s from './header.module.css';
import {UserBlock} from "../../modules/User";
import {NotificationsScreen} from "../../pages/NotificationsScreen/index";

export default function Header() {
    const [isMenuHovered, setIsMenuHovered] = useState(false);
    const isProduction = process.env.REACT_APP_ENVIRONMENT === 'production';

    return (
        <header className={s.header}>
            <div className={s.leftBlock}>
                <div
                    className={s.menuWrapper}
                    onMouseEnter={() => setIsMenuHovered(true)}
                    onMouseLeave={() => setIsMenuHovered(false)}
                >
                    <Menu className={s.menuIcon}/>
                    <div className={`${s.sideMenu} ${isMenuHovered ? s.visible : ''}`}>
                        <Navigation/>
                    </div>
                </div>

                <Link className={s.homeLink} to="/">
                    <Logo className={s.logo}/>
                </Link>
                <div className={s.nameApp}>
                    <span hidden={!isProduction}>Looking AI</span>
                    <span hidden={isProduction}>Тестовая админка</span>
                </div>
            </div>

            <div className={s.rightBlock}>
                <NotificationsScreen/>
                <UserBlock/>
            </div>
        </header>
    );
}